import { Avatar, Button, Card, CardActionArea, Chip, CircularProgress, Dialog, Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { DialogCloseTransition } from 'components/DialogTransitions';
import { ProductContentDialog } from 'pages/CustomerBookingCreate/2.2/ServicePackages/ProductContentDialog';
import { autoPopupServiceState } from 'pages/CustomerBookingCreate/state';
import { useEffect, useState } from 'react';
import ReactJson from 'react-json-view';
import { useRecoilState } from 'recoil';
import { fmtColor } from 'util/format';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    height: 300*.6,
    width: 225*.7,
    flex: 'none',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[10],
      transform: 'scale(1.05)',
    },
    cursor: 'pointer',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'flex-start',
    position: 'relative',
  },
  serviceIcon: {
    width: 'auto',
    flex: 0,
    height: 315*.6,
    alignSelf: 'flex-end',
    objectFit: "cover",
    objectPosition: "bottom",
    position: 'absolute',
    bottom: 0,
    right: -20,
    zIndex: 0
  },
  serviceInfo: {
    flex: 1,
    alignSelf: 'normal',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: theme.spacing(1),
    alignItems: 'flex-start',

    "&>h3": {
      textShadow: '2px 2px 5px rgba(0,0,0,0.10)'
    },

    color: theme.palette.common.white,
    "&>h6": {
      paddingBottom: theme.spacing(1.5)
    },
    zIndex: 1
  },
  serviceAction: {
    flex: 0,
    width: 75,
  },
  svcIcon: {
    height: theme.spacing(1.5),
    width: 'auto',
  },
  chip: {
    boxShadow: theme.shadows[1],
  },
  dialogPaper: {
    background: (props) => `linear-gradient(30deg, ${fmtColor(props?.header_start_color)} 0%, ${fmtColor(props?.header_end_color)} 100%)`
  }
}));

const ServiceCard = ({
  service,
  onSelect = (card) => { },
  onRemove = (card) => { },
  baseFee = 0,
  isSelected,
  canAddToCart
}) => {
  const styleProps = {
    header_start_color: service?.header_start_color,
    header_end_color: service?.header_end_color,
    header_text_color: service?.header_text_color,
  }
  const classes = useStyles(styleProps)
  const trackEvent = useTrackEvent()

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  const [autoPopupService, setAutoPopupService] = useRecoilState(autoPopupServiceState);

  const [showDialog, setShowDialog] = useState(false);

  const [openAuto, setOpenAuto] = useState(false);
  useEffect(
    () => {
      const isPackageIn = autoPopupService?.packages?.map(p => p.id).includes(service?.id)
      setOpenAuto(isPackageIn)
      setShowDialog(isPackageIn)
    }, [autoPopupService]
  );

  const [loading, setLoading] = useState(false);
  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Dialog
        maxWidth="sm"
        scroll='paper'
        fullWidth
        fullScreen={isMobile}
        open={showDialog}
        onClose={() => {
          trackEvent('Create Booking Product Content Dialog - close', { service: service?.label })
          setShowDialog(false)
        }}
        classes={{
          paper: classes.dialogPaper
        }}
        TransitionComponent={DialogCloseTransition}
      >

        <ProductContentDialog
          canAddToCart={canAddToCart}
          isSelected={isSelected}
          isExtendedPackage
          item={service}
          onSelect={async () => {
            setLoading(true)
            trackEvent('Create Booking Product Content Dialog - add to cart', { service: service?.label })
            await onSelect(service)
            setShowDialog(false)
            setLoading(false)
          }}
          onRemove={() => {
            setShowDialog(false)
            trackEvent('Create Booking Product Content Dialog - remove from cart', { service: service?.label })
            onRemove(service)
          }}
          onClose={() => setShowDialog(false)} />
      </Dialog>
      <Card
        className={classes.root}
        style={{
          background: `linear-gradient(30deg, ${fmtColor(service?.start_color)} 0%, ${fmtColor(service?.end_color)} 100%)`,
        }}>
        {/* {json} */}
        <CardActionArea onClick={() => {
          trackEvent('Create Booking Product Content Dialog - open', { service: service?.label })
          setShowDialog(true)
        }} className={classes.container}>
          <img className={classes?.serviceIcon}
            src={`${service?.icon_url}`}
          />
          <div className={classes?.serviceInfo}>
            <Typography
              style={{
                color: fmtColor(service?.text_color)
              }}
              variant='h5'>{service?.label}</Typography>

            <div style={{ flex: 1, }} />
            {service?.booking_type?.label && (
              <Chip
                size="small"
                className={classes.chip}
                style={{
                  color: service?.booking_type?.fg_color,
                  backgroundColor: service?.booking_type?.bg_color,
                }}
                icon={
                  <Avatar variant="square" className={classes.svcIcon} src={service?.booking_type?.icon_url} />
                }
                label={service?.booking_type?.label}
              />
            )}
          </div>

        </CardActionArea>
      </Card>
        <CardActionArea >
          {isSelected ?
            (
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={() => {
                  (trackEvent('Create Booking Product Card - Remove from cart'))
                  onRemove(service)
                }}>Remove</Button>
            ) : (
              <Button
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} />}
                variant="contained"
                color="primary"
                fullWidth
                onClick={async () => {
                  setLoading(true)
                  trackEvent('Create Booking Product Card - Add to cart')
                  await onSelect({
                    ...service,
                    
                  })
                  setLoading(false)
                }}>Add</Button>
            )}
        </CardActionArea>
    </div>
  )
}


export { ServiceCard };
